export default {
  // progressitem Components
  // 身份认证模块
  identity: {
    identityCer: 'identity certification',
    note: 'note',
    noteDes:
      'please enter the correct identity information of the cardholder(insured) to help the verification process.',
    IDtype: 'IDtype',
    IDNumber: 'ID number',
    IDvaliddate: 'ID valid date',
    validPlace: 'please enter ID valid date',
    IDexpireddate: 'ID expired date',
    expirPlace: 'please enter ID expired date',
    tips: 'Please select where you live in order to recommend more appropriate medical resources for you',
    region: 'region',
    placePegion: 'select a region',
    address: 'address',
    placeaddress: 'please enter your address',
    tips1: 'ID valid date cannot be longer than ID expired date',
    tipInfo:
      'Tips: Please be sure to add the correct identity information of the insured, otherwise the claim application will not be made.',
    tipArea:
      'Please select your location of residence and relevant information in order to recommend more appropriate medical resources for you',
    tipTit: 'Warm reminder:',
    tipUserCenter: `Incomplete identification information on your current policy will affect your claim review. Please add your ID photo and personal information on the current page.`
  },
  progressItem: {
    payNum2: 'NO.',
    payNum: 'Authorization number',
    payNum1: 'Claim number',
    tit: 'Multi-case Pre-authorization',
    tit1: 'Multi-case claims',
    serPerson: 'Policy number/Patient name',
    place: 'Provider Name',
    need: 'Need to supplement',
    diagnose: 'Diagnosis',
    material: 'Upload claim materials',
    material1: 'Supplementary claim materials',
    cancel: 'Revoke the application',
    des: 'EOB',
    materialStatus: 'Materials to be supplemented',
    cancleReason: 'The reason of cancel: ',
    remark: 'Remark',
    des1: 'Explain for the claims',
    promptTit: 'Prompt',
    prompt1: 'After deletion, you will no longer be able to edit the case',
    prompt2: 'Are you sure to delete？',
    promptBtn: 'Delete',
    prompt11:
      'After the revocation, you will no longer be able to edit the case',
    prompt21: 'Are you sure to revocate？',
    promptBtn1: 'Revocate',
    date: 'Visit date',
    promptBtnCancel: 'Cancel',
    examDate: 'Audit Date',
    closeTime: 'Closing Time'
  },
  // login 登录模块
  login: {
    loginTile: 'Welcome to MediLink-Global',
    loginSubTitle: 'Use your phone number to sign in our account',
    inputMobile: 'Phone number(No country code)',
    agreed: 'I have read and agreed with the ',
    apa: 'Automatic Payment Agreement',
    retrievePassword: 'Forget your password?',
    codeSignIn: 'SMS code sign in',
    passwordSignIn: 'Password sign in',
    btn_signin: 'Sign in',
    china: 'China',
    hongKong: 'Hong Kong',
    USA: 'USA',
    UK: 'UK',
    UAE: 'UAE',
    inputPassword: 'Please enter the password',
    errorPhone: 'Wrong number. Please enter the correct number',
    inputCode: 'SMS Code',
    errorCode: 'Please enter correct CAPTCHA',
    agreement: 'Please confirm and agree the automatic debit agreement',
    inputNewPwd: 'New password',
    confirmNewPwd: 'Confirm new password',
    findPassword: 'Retrieve password',
    notSame: 'The two passwords are inconsistent',
    btn_resend: 'To resend ',
    btn_sendCode: 'Send code',
    qrCode: 'Please show the QR code to the hospital when you see a doctor', // 0
    cardPackage: 'Add to WeChat card package'
  },
  // member模块
  member: {
    viewPersonalInfo: 'View my information',
    add: 'Add insurance card', // 添加保险卡
    insuranceBenefits: 'My benefits',
    InsuranceCardForFamily: 'Linked to family members card',
    takeEffect: 'Take effect',
    takeExpire: 'Expire',
    allPolicy: 'Policy',
    claimApplication: 'Claim',
    preAuthApplication: 'Pre-authorization',
    medicineForChronic: 'On-line \n Pharmacy \n deliver',
    seeDoctor: 'Healthcare Providers',
    globalNetwork: 'Global Network',
    Appointment: 'Appointment',
    bussinessProgressQuery: 'Processing status',
    pendingDeductible: 'Outstanding payment',
    messagePush: 'Message settings',
    survey: 'Satisfaction Survey',
    medicalRecordQuery: 'Doctor Reviews and Rating',
    otherService: 'Others Service',
    contactCustomerService: 'Service Hotline',
    title: 'Customer Satisfaction Survey',
    content:
      'Dear Member,<br/>Thank you for your trust and support to Medilink-Global, in order to improve our service quality and provide you with better services & pleasing experience, we sincerely invite you to participate in our satisfaction survey. We are looking forward to your valuable comments, thank you!',
    cancel: 'Cancel', // 取消
    participate: 'Go Participate',
    memberCenter: 'Member Center',
    cardNo: 'Card No.',
    memberName: "Member's Name",
    companyName: "Company's Name",
    memberNo: "Member's No.",
    effectiveDate: 'Effective Date',
    customBg: 'Custom Background',
    default: 'System Default',
    toUse: 'To Use',
    Using: 'Using',
    fontColor: 'Font Color',
    uploadBg: 'Upload Background',
    uploadTip:
      'It is recommended to upload a background image of 1920*1080 size',
    save: 'Save',
    preview: 'Preview',
    selectTip: 'Please select a background image',
    inuseDel: 'It is in use and cannot be deleted',
    changeToUhc: 'switch to the U.S insurance card',
    changeToOrigin: 'switch to the original insurance card',
    front: 'FRONT SIDE',
    back: 'BACK SIDE',
    privacyAgreement: 'Privacy Agreement',
    perInfo: 'personal information',
    bindSuccess: 'Binding successful'
  },
  // 金牌医生
  doctorAppointment: {
    home: {
      appointDoctor: 'Appoint Doctor',
      appointTip: "Please find doctor' information",
      appointmentRecords: 'Appointment records',
      recordTip: 'Appointment status checking'
    },
    serviceRecord: {
      all: 'All',
      reserved: 'Reserved',
      cancelled: 'Cancelled',
      time: 'Time',
      O: 'On processing',
      I: 'Reviewing',
      C: 'Appointment Completed',
      L: 'Cancellation',
      OTip: 'Appointment is on processing, please be patient',
      ITip: 'Your appointment is on processing.',
      CTip: 'Appointed succeed, please arrive on time',
      LTip: 'Appointment canceled',
      caseNumber: 'Case number',
      expectedAppointmentTime: 'Expected appointment time'
    },
    appointDetail: {
      offices: 'offices',
      phone: 'Contact number',
      serviceTime: 'Date/time of service',
      address: 'Hospital address',
      office: 'Treatment office',
      info: 'Patient information',
      name: 'Name',
      appointmentInfo: 'Appointment information',
      reschedule: 'Reschedule appointment ',
      back: 'Back',
      remark: 'Remark',
      cancel: 'Cancel appointment',
      range: 'Time range preferred',
      selectTime: 'Please select the appointment time ',
      O: 'Schedule initial time:',
      I: 'Reviewing time:',
      C: 'Appointment schedule initial time:',
      L: 'Cancellation time:'
    },
    appointSelection: {
      searchPlaceholder:
        'Please search the treatment offices or doctor’ name you would like to appoint',
      allDoctors: 'Doctors’ information',
      allOffices: 'offices'
    },
    doctorList: {
      searchHistory: 'Search history',
      more: 'More information',
      appointment: 'Make appointment ',
      advance: 'Book at least one day in advance',
      level: 'Search by doctor’ level',
      doctor: 'Chief physician',
      associateDoctor: 'Associate Chief physician',
      attendingDoctor: 'Attending physician',
      nodata: 'NO Data',
      offices: 'Offices',
      hospital: 'Attending Hospital',
      phone: 'phone',
      pt: 'Period of time',
      st: 'Please select time',
      to: 'to',
      cancle: 'Cancle',
      confirm: 'Confirm'
    },
    doctorDetail: {
      introduction: 'Physician introduction',
      hospital: 'Attending Hospital',
      phone: 'Contact number',
      experience: 'Experience',
      specialty: 'Specialty',
      making: 'Appointment making',
      date: 'Expected appointment date',
      select: 'Please select',
      time: 'Expected appointment time',
      info: 'Patient information',
      notice: 'Notice of Appointment',
      process:
        'Appointment process:  The medical service appointment would require the patient provide the details of your ID for authentication ,  including name, ID number, gender, age, mobile phone number etc, so as to complete the registration of your appointment .',
      succeeded:
        'Appointment succeeded: Upon having confirmed, we will inform you the appointment status, and you also can check the updates or progress from MediLink-Online.',
      modification:
        'Appointment Change/cancellation  : If any change/Cacellation , please click " cancellation button"  on the page.  ASAP in 24 hours recommended! If appointment  change, please reschedule it accordingly.” ',
      access:
        'Quick Reservation Access: The earlisest appointment could  be made on the same day when available; if not, the appointment schedule will be confirmed in the next day. To receive medical treatment in 7 days is guaranted!',
      schedule: "Doctor' schedule in hospital is just for reference.",
      toast: 'Please improve the medical information！',
      remark: 'remark',
      remarkPlaceholder: 'Please enter the remark',
      onHospital: 'hospital'
    }
  },
  // 线上送药
  onLinePharmacyDelivery: {
    title: 'On-line Pharmacy delivery',
    apply: 'Apply for Pharmacy Delivery',
    know: 'Need-to-Know for Pharmacy Delivery',
    progress: 'Progress Inquiry',
    check: 'Check progress of the approved deliveries',
    policy: 'Policy Number',
    choose: 'Please choose your insurance plan accordingly',
    des: 'The service is limited for the product package with Pharmacy Delivery Service. If needed, please tender your application at least one week earlier so as to assure the pharmacy can be delivered in time.',
    number: 'Policy number:',
    insured: 'Policy number:',
    Membership: 'Membership number:',
    year: 'Policy year:',
    phone: 'Telephone number',
    mail: 'Email address',
    next: 'Next step',
    notice: 'Service Notice',
    readtit: 'Please read the following information carefully:',
    readone:
      '1、The pharmacy vendor of this service is independent vendor with required license by law: However, MediLink will fulfill our duty to check the qualification and capability routinely to assure the service quality. Just a reminder: When you apply for this service, MediLink would need to release your personal information including the diagnosis, prescription etc to the pharmacy vendor as needed. ',
    readtwo:
      '2、Pharmacy delivery service is limited to the prescription medicines after consultation with doctors.  The medicines are also limited to OTC and dual-track prescription medicines, but the following monorail prescription medicines (psychiatric, antibiotics, insulin, biological agents, sleeping pills, narcotic medicines, etc.) are excluded.',
    readthree: `3、For the safety reason, we suggest you use this service only when:
	If chronic diseases:
	- You have taken the existing medication for more than 3 months.
	- Your illness condition is stable.
	- There is no need to adjust the usage or dosage of the medicine.
	If usual or common diseases:
	- You would need to assure there is no adverse reaction to the medicine in your medical history.
	If you are not feeling well after taking the medicine, Please seek medical advice immediately,
	`,
    readfour:
      '4、The pharmacy delivery service is based on valid medical records or  prescriptions.  For chronic disease, the service could provide maximum 90 days’ medication fulfillment; For common disease, the dosage would follow the medical consultation from doctors according to your valid medical documents. If pharmacy delivery services still needed after then, please go to a regular hospital for a follow-up consultation; then provide us the latest medical records and prescriptions (drug usage, dosage）',
    readfive:
      '5、Under the same diagnosis, the application dosage should not exceed the prescribed dosage, or further application before the dosage being used up is not to be reimbursed. This restriction is also applied to other medicine sources (including but not limited to medical institutions, pharmacies, etc.). If any breach, your claim could be rejected.',
    readsix:
      '6、If any uncontrollable or irresistible  reason (such as changes of pandemic, internet medical service policy etc) results in the required medicines not deliverable, MediLink reserves the rights to cancel the service. ',
    understood:
      'I have fully understood and accepted the relevant content and regulations of the pharmacy delivery and direct billing service',
    upload: 'Upload medical information ',
    materials: 'Please upload relevant medical materials',
    updes:
      'For chronic disease, the service could provide maximum 90 days’ medication fulfillment; For common disease, the dosage would follow the medical consultation from doctors according to your valid medical documents. If pharmacy delivery services still needed after then, please go to a regular hospital for a follow-up consultation; then provide us the latest medical records and prescriptions (drug usage, dosage）',
    names: 'Name of Medicine / pharmacy',
    dosage: 'Dosage',
    cancel: 'cancel',
    ok: 'ok',
    select: 'Please select (one month dose is recommended)',
    fiveDays: '5Days',
    weeks: '2Weeks',
    onemonth: '1Month',
    twomonth: '2Months',
    threemonth: '3Months',
    other: 'others',
    usage: 'Prescription List ( Usage, Dosage, Drug packaging)',
    record:
      'Medical record ( Latest medical record valid in one year is required)',
    id: 'ID/Passport',
    mailinfo: 'Mail information',
    mailinginfo: 'Please fill your mailing information',
    maildes:
      'To assure your medication can be delivered in time, please inform us at least 1 week before your need of the pharmacy.',
    consignee: 'Consignee',
    tel: 'Tel',
    address: 'Address',
    addressdetail: 'Detailed address（**Street**Number**）',
    city: 'City/areas',
    door: 'Address number',
    save: 'Whether to save the address',
    expected: 'Expected delivery time',
    remark: 'Remark',
    remarkdes:
      'If you have any other requests, please fill in here (optional, maximum 80 Chinese characters or 160 digits characters).',
    sign: 'Electronic Signature',
    confirm: 'Please confirm that the information is correct',
    signature:
      '“Application form of Pharmacy Delivery Services for Chronic Diseases” automatically generated based on electronic signature',
    modify: 'Modify',
    complete: 'Complete',
    back: 'back',
    all: 'All Submitted Requests',
    submitted: 'Submitted',
    processing: 'Processing',
    completed: 'Completed',
    invalid: 'Invalid application',
    time: 'Time',
    pt: 'Period of time',
    st: 'Please select time',
    to: 'to',
    case: 'Case number',
    detail: 'Detail',
    nodata: 'No Data',
    sb: 'Submitted by',
    process: 'Processing',
    approved: 'Approved',
    rejected: 'Rejected',
    canceled: 'Canceled',
    citypicker: 'City Picker',
    emptycity: 'Please select city/region',
    emptyname: 'Please enter the name of consignee',
    emptyphone: 'Please enter the consignee telephone number',
    emptyrecivedarea: 'Please enter the receiving city/region',
    emptyaddress: 'Please enter the shipping address',
    emptynumber: 'Please enter the house number',
    subsuccess: 'Your application has been submitted！',
    saveerr: 'Save failed',
    policyNo: 'Please select policy',
    enternumber: 'Please enter phone number',
    enteremail: 'Please enter  email',
    aftersign: 'Please sign and click the complete',
    read: 'Please read and check the contents and regulations related to direct payment service in pharmacy',
    signatureBtn: 'signature',
    remove: 'Remove',
    btnConfirm: 'Confirm',
    signatureConfirm: `Please ensure that your electronic signature is clear and complete. The signature will be regarded as your confirmation of this claim application. Your signature will be displayed in the patient's signature section of the Claim Application Form. If the patient is a minor, it shall be signed by the applicant.`,
    datePlaceHolder: 'Please select Date',
    cancle: 'Cancle',
    trackingNo: 'Tracking No',
    confirmReceipt: 'Confirm receipt',
    receiptsuccess: 'Received successfully！',
    confirmInfo: 'Confirm Info'
  },
  // 全部保单
  allPolicy: {
    backTime: 'surrender date', // 退保日期
    effective: 'Valid policy',
    effectiveCard: 'Effective card',
    historyCard: 'History card',
    history: 'History policy',
    placeHolder: 'Input card no',
    serNum: 'Policy number',
    serPerson: 'Principle',
    serCard: 'Member Card',
    serPerson1: 'Dependent',
    serDate: 'Insurance period',
    bx: 'benefits',
    policyM: 'Policy Manange',
    cardM: 'card Manange'
  },
  queryhospital: {
    all: 'All',
    area: 'Location',
    plan: ' All Products',
    property: 'Nature',
    class: 'Category',
    level: 'Level',
    placeHolder: 'Hospital name',
    hProperty: 'Hospital nature',
    hClass: 'Hospital category',
    nearby: 'Now',
    locFail: 'Positioning failed, click reposition',
    toastLocFail:
      'Positioning failed!Make sure if your WeChat positioning is enabled',
    locSuc: 'Positioning success',
    prompt: 'mediLink-global want to access location ',
    btn1: 'Refuse',
    btn2: 'Accept',
    yuyue: 'Appointment',
    nodatap: 'No hospital resources',
    hospitalQuery: 'Search hospital',
    Y: 'Y',
    N: 'All',
    fullhours: '24H',
    emergency: 'Emergency',
    propertyOptions: {
      all: 'All',
      p1: 'Private',
      p2: 'Public',
      p3: 'Foreign investment'
    },
    to: 'TO',
    hospitalDetail: {
      tit: 'Hospitel Detail',
      serviceTit: 'Service satisfaction',
      des: 'introduction',
      yuyuebtnhos: 'Appointment',
      back: 'back',
      tab: {
        des: ' Hospital introduction',
        service: 'Related services'
      },
      tabcon1: {
        hospitalProperty: 'Hospital nature',
        fullhours: '24H',
        emergency: 'Emergency',
        hospitalClass: 'Hospital category',
        specificClass: 'Specialty category',
        top100: 'Top 100 Departments',
        openTime: 'Opening hours',
        docPrompt: 'Tips',
        stationaryService: 'Stationary Service',
        stationaryWorkTime: 'Stationary WorkTime'
      },
      tabcon2: {
        question1: 'How to arrive to the direct billing service department',
        question2: 'Expertise Speciality',
        question3: 'Inpatient Service',
        question4: 'Direct billing service flow',
        question5: 'Medical experience'
      },
      lookAll: 'LookAll',
      map: 'Hospital Adress',
      to: 'TO'
    },
    hospitalSearch: {
      search: 'Search',
      searchHistory: 'Search history',
      placeHolder: 'Hospital name'
    }
  },
  // 医院预约
  hospitalappointment: {
    isMajorIllness: 'Critical Illness:',
    Appointmentingtab: 'Processing',
    Appointmentendtab: 'Completed',
    orderNo: 'Query Number:',
    appointdocdep: 'Department and Doctor:',
    dateandtime: 'Appointment Date and Time:',
    empName: 'Insured:',
    cancelyy: 'Cancel',
    againYY: 'Again',
    P: 'Processing',
    I: 'Processing',
    O: 'Submitted',
    C: 'Completed',
    L: 'Cancel',
    F: 'Failed',
    yuyuebtn: 'Make an appointment',
    yuyuebtnhos: 'Appointment',
    back: 'back',
    baoxianNo: 'Insurance Card:',
    Contact: 'Contact:',
    Languageofvisit: 'Language:',
    institutions: 'Provider:',
    address: 'Address:',
    Telephone: 'Telephone:',
    Department: 'Department:',
    Doctor: 'Doctor:',
    date: 'Date:',
    time: 'Time:',
    ramker: 'Remark：',
    writeOrder: 'Fill in the appointment form',
    submitOrder: 'Submit appointment information',
    placecardno: 'Please select insurance card number',
    placeempName: "Please fill in the patient's name",
    placehpno: 'Please fill in the contact information of the patient',
    placeproviderName: 'Please select a provider',
    placeaddress: '/',
    placephone: '/',
    placedepartment: '',
    placedoctor: '',
    placedate: '',
    placetime: '',
    placeMarker:
      'If there are alternative hospitals, alternative departments, alternative doctors, alternative date and time, please fill in here(not required,within 160 characters)',
    applySuccess: 'success',
    quxiaoSuccess: 'Successfully canceled the appointment!',
    addnews: 'Please complete the information',
    nologin: "You haven't logged in yet!",
    yuyueOn: 'Make an appointment',
    yuyuejigou: 'Provider:',
    querencancel: 'Are you sure you want to cancel the appointment?',
    queding: 'Yes',
    cancel: 'No',
    tipYuyue:
      "The list of provider doesn't match the insured, the insured has been be automatically replaced.",
    selectlan: 'Language',
    selectDate: 'Date',
    selectTime: 'Time',
    nodata: 'No appointment record',
    symptom: 'Symptom：',
    placesymptom: 'Please enter your symptoms (required,within 160 characters)',
    healthInfo1:
      'Contact history: Is the health status in the health code of the patient and the accompanying person as "no abnormality (green)"? Is there a recent history of medium-to-high risk overseas or domestic travel? Have you been in contact with someone suspected of being infected with the new coronavirus recently?',
    healthInfo2:
      "Suspected symptoms: Has the patient's body temperature ≥37.3°C within 3 days (except for long-term fever caused by a clear disease) or has suspected symptoms such as dry cough, sore throat, sputum, hyposmia and taste loss?",
    healthInfoFlag1: 'Yes',
    healthInfoFlag2: 'No',
    des1: 'Additional information',
    des2: 'Please briefly explain the situation',
    prompt:
      'This provider does not currently support weekend appointments, please select another date',
    dateTitle: 'Date',
    againtitle: 'again Booking',
    eduittitle: 'Fill in the reservation form',
    title: 'Detail',
    dateTip:
      'Note: If you need to make a same-day appointment, please call 400-114-9606 to consult the same-day number source'
  },
  // 就医体验
  medicalevaluation: {
    hospitalJudge: 'Medical experience',
    tit: 'Service satisfaction',
    placeHolder: 'Talk about your medical experience within 200 words',
    submit: 'Submit anonymously',
    submitBtn: 'Submit',
    nomore: 'No more',
    dateTip:
      'Note: If you need to make an appointment for a visit on the same day, please dial 400-114-9606 to inquire about the number source of the day'
  },
  // 就诊记录查询
  serverdInstitutionSearch: {
    consultantInfo: 'Consultant information',
    guidance: 'Guidance',
    videoDoctor: 'Video doctor',
    consultationSummary: 'Consultation summary',
    consultationTime: 'Consultation time',
    consultant: 'Consultant',
    consultantNo: 'Consultation No',
    finished: 'Completed',
    inProgress: 'Diagnosis in progress',
    processing: 'Processing',
    claimNo: 'Claim No',
    closeCase: 'Closed case',
    selfClaim: 'Self-service claims',
    hProperty: 'The nature of the medical facility',
    hClass: 'The category of the medical facility',
    practice: 'Rate your experience',
    ViewMedicalExperience: 'View medical experience',
    date: 'Visit date',
    patient: 'Patient',
    diagnose: 'Diagnosis',
    tips: "The above conclusions provide suggestions according to the user's description and are only for reference. If the symptoms are not relieved, aggravated or other discomfort occurs, please go to the hospital in time. Thank you for your use."
  },
  claimQuery: {
    promptTit: 'Prompt',
    prompt11:
      'After the revocation, you will no longer be able to edit the case',
    prompt21: 'Are you sure to revocate？',
    promptBtnCancel: 'Cancel',
    promptBtn1: 'Revocate',
    prompt1: 'After deletion, you will no longer be able to edit the case',
    prompt2: 'Are you sure to delete？',
    promptBtn: 'Delete',
    all: 'All',
    wait: 'Pending to submit',
    mid: 'Under review',
    have: 'Case closed',
    time: 'Time',
    paymentQuery: 'Self-service claims progress query',
    nodatap1: 'No related content found',
    timeOption: {
      all: 'All',
      year: 'A year',
      halfYear: 'Half a year',
      month: 'Three months'
    },
    noReduceTip:
      'This claim only deducts the coverage amount and does not count towards the number of outpatient claims.'
  },
  // claim explain
  claimExplain: {
    claimInfoTit: 'Claim Informatin',
    claimNo: 'Claim Reference No.',
    policyNo: 'Policy No.',
    claimant: 'Claimant',
    cardNo: 'Card No.',
    hospital: 'Hospital',
    diagnosis: 'Diagnosis',
    admissionDate: 'Admission Date',
    dischargeDate: 'Discharge Date',
    icuDays: 'No. of Days (ICU)',
    days: 'No. of Days',
    chargeDetailsTit: 'Charge Details',
    description: 'Description',
    policyLimit: 'Policy Limit',
    amtIncurred: 'Bill Amount',
    amtApproved: 'Approval Amount',
    amtToPay: 'Self Pay Amount',
    total: 'Total',
    remarks: 'Remarks'
  },
  // 消息中心
  messageAbout: {
    noNews: 'No news',
    noContentYet: 'No content yet',
    messageCenter: 'Message Center', // 消息中心
    myMessage: 'My message', // 我的消息
    messageNotice: 'Message Notice', // 消息通知
    promotions: 'Promotions', // 优惠活动
    readAll: 'Read All', // 消息中心
    clear: 'Clear', // 清空
    all: 'All',
    read: 'Read',
    notRead: 'Unread',
    othersService: 'Others Service', // 其他服务
    messagePush: 'Message center', // 消息推送
    langSetting: 'Language', // 语言设置
    feedback: 'Feedback', // 意见反馈
    registerDate: 'Date of registration', // 注册日期
    signOut: 'Log out', // 退出登录
    confirmCallTel: 'Are you sure you want to call' // 确定拨打电话：
  },
  // 自助理赔
  claim: {
    claimApply: {
      saveTips: 'Your data will be saved until 24:00 today',
      help: 'what is self-service claim', // 什么是自助理赔？
      viewDetail: 'View the details',
      policy: 'Policy Number',
      upload: 'Doc Upload',
      done: 'Done',
      notice: 'Claims instruction',
      writeApply: 'Fill up the request',
      nextStep: 'Next Step',
      knowNotice:
        'Please pay attention to the followings before submitting your application!', // 提交申请前, 请您注意以下事项！
      notification: 'Insurance Fraud Notification',
      statement: 'Statement of Consent',
      readAgreed: 'I have read and agreed to',
      know: 'I got it',
      antiFraudClause: `
      <p>Important Information – please find below the applicable anti-fraud regulations dictated by the Chinese insurance laws:</p>
      <p>Criminal Law: An applicant, insured person or beneficiary who is guilty of committing insurance fraud shall be sentenced to fixed-term imprisonment for a maximum of 10 years, and concurrently be sentenced to a fine or confiscation of property. Any appraiser, assessor or attester, who deliberately provides false certification documents, thus providing conditions for the applicant, insured person or beneficiary to carry out insurance fraud, shall be charged as an accomplice of insurance fraud (see Article 198 of the Criminal Law of the People’s Republic of China)</p>
      <p>Administrative Law: An applicant, insured person or a beneficiary who commits an insurance fraud act (which does not constitute a crime) shall face a detention of maximum 15 days or a maximum fine of 5,000 Yuan. Any appraiser, assessor or attester who deliberately provides false certification documents, thus providing conditions for the applicant / the insured person / beneficiary to carry out insurance fraud, shall be charged accordingly (see Article 16 and Article 21 of the “Decision of the Standing Committee of the National People’s Congress on Punishment of the Crimes of Undermining the Financial Order”).</p>
      <p>Civil Law: If the applicant fails, due to intention or gross negligence, to perform his/her obligation of making a full and accurate disclosure, or the applicant / insured person intentionally causes the occurrence of an insured event, the insurer has no obligation to make any indemnity or payment of insurance benefit. If the applicant / the insured person / beneficiary, following the occurrence of an insured event, provides forged or altered relevant evidence, information or other proofs or falsifies the cause of the occurrence of the insured event or overstates the extent of the loss, the insurer has no obligation for indemnity or to make payment of the insurance benefit for the portion which is falsified or overstated (see Article 16 and Article 27 of the Insurance Law of the People’s Republic of China)</p>
      `,
      claimApplyConfrim: `
      <p>I agree that, for any reason, I will pay the full amount of any fees that my insurance policy does not cover during my direct billing service. I agree that Medilink or my insurance company contact me and collect the fees from me via my bank transfer. I further agree that if I do not pay these fees in time, I will be personally responsible for all costs of the collection, which include any reasonable legal costs, related costs incurred by insurance company, Medilink and /or the medical facility.</p>
      <p>For the necessity of underwriting, claim and related service, I agree that insurance company, medical facility and Medilink share my related insurance benefit, health and/or medical information. I authorize any physician, medical facility, pharmacist, insurance company, employer, labor union, or association to release such information to Medilink and my insurance company. The information includes copies of medical records, concerning advice, care or treatment plan. I hereby confirm that the above statements are true and complete. For the necessity of claim and related service,I agree that the insurance company or Medilink handle the claims money on my behalf.I agree to provide any additional information as further required.</p>
      <p>For Direct Billing case or guaranteed case which the medical treatment received in the pre-appointed provider,I hereby authorize the provider or pre-appointed third party to directly bill my insurance company which should make payment of any benefit payable to the provider or pre-appointed third party.</p>
      <p>A photocopy of the above authorization shall be considered as effective and valid as original document.</p>
      `,
      notice1:
        'Do not submit the claim for the same medical treatment repeatedly, The same disease of the same medical institution on the same day is regarded as one claim',
      notice2:
        'Self-service claims allow to submit a claim for less than {amount} RMB (including),after the settlement of claims of more than {amount} RMB shall be submitted offline. Please refer to the insurance service manual for the mailing address of claims information.',
      notice3:
        'To ensure that you receive your claim as soon as possible,Please fill in the bank information according to the rules of bank name + city + branch name  Example: China merchants bank guangzhou huacheng sub-branch',
      notice4:
        'in order to ensure the payment is received as soon as possible，pleae confirm the name of the insured in advance, and submit in the correct insured to get the compensation',
      notice5:
        'Self-help claim is the traditional reimbursement model, the insured person to pay the fully amount to medical institution, and submit the invoice, medical records, the examination report, reimbursement request form eg. to the insurance company or the third party authorized by an insurance company to get the reimbursement amount.',
      policyNo: 'Policy number', // 保单号
      policyPeople: 'Patient Name', /// 就诊人
      effectInsureTime: 'Insurance period', // 保险有效期
      surrenderTime: 'Surrender date', // 退保日期
      applayer: 'Applicant', // 申请人
      applayerHolder: 'Please enter the applicant name', // 请输入申请人
      relationWithInsured: 'Relationship with patient', // 与就诊人关系
      chooseRelation: 'Relationship with the patient at risk',
      medicalLocation: 'Location Of Medical Institution',
      medicalLocationHolder:
        'Please choose the location of medical institution', // 请输入医疗机构所在地
      medicalInstitution: 'Provider Name', // 医疗机构
      medicalHolder: 'Please enter the name of the medical institution', // 请输入医疗机构名称
      preDoctorTime: 'Visit date',
      seeDoctorHolder: 'Visit date', // 请选择就诊日期
      treatmentType: 'Treatment type', // 就诊类型
      poliyDutyHolder2: 'Treatment type', // 请选择就诊类型
      applyMoney: 'Amount Requested', // 申请金额
      moneyAccount: 'Remittances account', // 汇款账户
      claimAccount: 'Bank Info', // 理赔款账户
      claimAccountP: 'Bank Info', // 请选择理赔款账户
      moneyHolder: 'Please fill in the amount', // 请填写金额
      bankaccnm: 'Account Name',
      openCardBK: 'Bank', // 开户行
      note: 'Note',
      tips: 'Adult users please choose their own bank card to receive claims, and minor users can use other bank cards to receive claims.</br>The claim payment account currency needs to match the currency of the claim',
      placeHolder2: 'Please enter your other request(125 words)',
      update_tip:
        'To successfully pass the audit Please provide the following materials The dot item is mandatory input field',
      example: 'Example',
      yes: 'YES',
      no: 'NO',
      tipsTitle: 'Tips',
      changePolicyTips:
        'If you choose a new policy number, the information you have filled in will be cleared, so please choose carefully.',
      kindReminding:
        "Kind reminding:please click policy number button and select  the insured person's policy number  if this submission is not for yourself.",
      back: 'Back',
      require: '-upload requirements', // -上传要求
      sampleTip: '', // 下图为示例说明，要求拍摄文字清晰
      signPreview: 'Electronic signature'
    }
  },
  preAuthApply: {
    help: 'What is pre-authorization', // 什么是预授权？
    viewDetail: 'View the details',
    // 1、无论是直接付费服务，还是事后理赔，对特定的医疗治疗项目，保险公司均需要您事先获得授权批准，否则可能导致您额外花费了部分非合理且必需的费用而无法在保险保障范围内得到赔偿。甚至，应授权而未授权的案例会造成理赔金额的降级赔付。
    notice1:
      '1. Whether it is a direct payment service or an after-sales claim, the insurance company requires you to obtain authorization and approval in advance for certain medical treatment projects, otherwise it may cause you to spend some unreasonable and necessary expenses beyond the insurance coverage Compensation. Even authorized and unauthorized cases will result in downgraded claims.',
    notice2:
      '2,Normally need pre-authorization application’s medical treatment: for all hospitalisation treatment; complex dental treatment; outpatient radiotherapy and chemotherapy for tumor; polyclinic surgery under general anesthesia; home nursing; amniocentesis(under 35years old pregnant women); purchase walking stick, wheel chair and hearing aid; contrast-enhanced CT/stereotactic radio therapy(gamma knife); other treatment that need pre-authorization in the plan.',
    notice3:
      '3,You need to inform the hospital to submit the pre-authorization request form for us before get above treatment, and let our mediLink global customer services team to get the request form at least 3 working days before you schedule the treatment date. You will get feedback within 48 hours since our mediLink global team and insurance company received the pre-authorization request form. If your cost was higher than normal range or the length of stay in hospital was too long, we may need more time to audit, normally you will get feedback within 5 working days. And, we may need other medical history documents for this request, that’s you and your attending physician may help us to provide, and let the audit get result as soon as possible.'
  },
  tips: {
    cancleBtn: 'Cancel',
    confirmBtn: 'Confirm',
    changePhoneNumber: 'The phone number to be bound',
    selectIdType: 'Please select idType',
    enterIdNumber: 'Please enter your ID number',
    enterMobileNumber: 'Please enter your phone number',
    enterEmail: 'Email (Not required)',
    genderPlaceHolder: 'Please select gender',
    datePlaceHolder: 'Please select Date',
    phoneTips:
      'The current mobile phone number is inconsistent with the mobile phone number you reserved when applying for insurance. Please contact the customer service personnel to modify it in the system for you to help you bind the card.'
  },
  // 线上问诊
  consultService: {
    healthConsultation: 'Health Consultation',
    healthConsultationDesc:
      'We could provide consultation of health management (no medicine delivery service), open to all family members.',
    onlineConsultation: 'Online Health Management',
    onlineConsultationDesc:
      'Online consultation service from public grade three hospitals, closed cycle service for consultation and pharmacy delivery.',
    videoDoctor: 'Video Doctor',
    videoDoctorDesc:
      'Enjoy face-to-face medical consultation services with your doctor',
    onlinePharmacyDelivery: 'Online Pharmacy Delivery',
    onlinePharmacyDeliveryDesc:
      'Apply for online pharmacy delivery service by providing us Prescription within half a year.'
  },
  // 在线问诊
  chooseBaodan: {
    policyNo: 'Policy number', // 保单号
    insured: 'Insured',
    effectInsureTime: 'Insurance period', // 保险有效期
    nextStep: 'Next'
  },
  // 以上已整理

  title: {
    home: 'home',
    claimApply: 'Claim', // "理赔申请",
    claimExplain: 'Claim explain',
    claimsBusiness: 'Settlement of claims', // "理赔业务办理",
    preAuth: 'pre-authorization', // "预授权办理",
    preAuthApply: 'Preauthorization application', // '预授权申请',
    preAuthDetail: 'Pre-authorization details', // '预授权详情',
    insureDuty: 'The insurance liability', // "保险责任",
    welfare: 'Insurance and welfare', // "保险福利",
    bankCard: 'Bank card management', // "银行卡管理",
    addBCard: 'Choose bank card', // "选择银行卡",
    addB: 'Choose bank', // 选择银行
    addC: 'Choose city', // 城市选择
    verifyTitle: 'Id Management Center',
    personalInfo: 'My information',
    modifyTitle: 'Modify',
    basicInfo: 'Basic Information',
    policyInfo: 'Policy information',
    material: 'Insurance materials'
  },
  buttons: ['Modify', 'Upload'],
  advice: {
    title: 'Please select the type of problem or suggestion you encountered',
    claimServices: 'Claim services',
    optSuggestion: 'Suggestions',
    complaints: 'Complaints',
    others: 'Others',
    comments: 'Comments',
    addPictures: 'Add pictures ',
    pictureLimit: '(you can add up to 3 pictures)',
    fillInfo: 'Fill in the information',
    username: 'Your name',
    fillUserName: 'Please fill in your name',
    yourGender: 'Gender',
    Male: 'Male',
    Female: 'Female',
    mobile: 'Mobile phone Number',
    contacts: 'Please fill in your contacts',
    feedback: 'Feedback'
  },
  userCenter: {
    info: 'My information',
    modify: 'Modify',
    upload: 'Upload',
    IDPhoto: 'ID photo',
    male: 'Male',
    female: 'Female',
    upload1: 'uploaded',
    noC: 'Not completed',
    unDate: 'Expired, re-upload',
    address: 'Address',
    uploadAgain: 'Re-upload'
  },
  updateUserInfo: {
    updateQuery: 'Information confirmation',
    updateEdit: 'Information modification',
    tipsTextOne:
      'In order to protect your personal health information privacy and important claim information notice; Please check your contact information and email address again.',
    tipsTextTwo:
      'If your information has changed, please enter the correct information.',
    phone: 'Phone',
    email: 'Email',
    tipEmailEpy: 'Mailbox cannot be empty',
    tipEmailErr: 'The mailbox format is incorrect',
    tipPhoneEpy: 'Mobile phone number cannot be empty',
    tipSuccess: 'Information change succeeded',
    btnConfirm: 'Confirm',
    btnModify: 'Modify',
    btnSubmit: 'Submit',
    btnCancle: 'Cancle'
  },
  other: {
    othersService: 'Other service'
  },
  userAbout: {
    inputNewPwd: 'New password',
    firstName: 'First Name',
    lastName: 'Last Name',
    name: 'Name',
    gender: 'Gender',
    birthDate: 'Date of Birth',
    nationality: 'Nationality',
    idType: 'ID Type',
    idNumber: 'ID Number',
    idCardValidity: 'Validity of a certificate',
    professionalCateory: 'Professional category',
    email: 'Email',
    address: 'Address',
    unfinished: 'Fill in the address',
    toModify: 'To modify',
    phoneNumber: 'Phone number',
    detailedAddress: 'Detailed address',
    placeholder_detailedAddress:
      'Please enter the detailed address, such as: street, house number, community, building number, unit room, etc.',
    inputName: 'Please enter real name',
    inputCardNumber: 'Please enter document number',
    idCard: 'ID card',
    passport: 'Passport',
    MTP: 'MTP',
    HMPasser: 'Hong Kong-Macau laissez-passer',
    brithCertify: 'Birth Certificate',
    forgetPassword: 'Forget password?',
    cannotReceiveCode: 'Cannot receive SMS code?',
    idCardAuth: 'Identity authentication',
    placeholder_idCardValidity: 'document validity',
    confirmPhone: 'Please confirm your mobile phone number:', // 请确认您的手机号：
    longTerm: 'Long-term', // 长期
    btn_Inquiry: 'Inquiry', // 查询
    uploadIdCard: 'Shoot/upload your China Second-Generation Identity Card ', // 拍摄/上传您的二代身份证
    uploadPassport: 'Shoot/upload your Passport', // 拍摄/上传您的护照
    note: 'Note',
    idCardHint:
      'Please enter the correct identity information of the cardholder(insured) to help the verification process. When you identity information bind to insurance card , you will not be able to change the identity information.',
    idCardHint1:
      'In order to review of your case quickly, please upload your photo ID (the information is only used for authentication, and the mediLink ensures your peronsal information safety)',
    idCardHint2: 'drop down to select the ID type you need to add',
    veriInformation:
      'Information is only used for authentication, mediLink-Global guarantees your information security',
    veriInformation1:
      'The other type include Hong Kong, Macao and Taiwan resident ID cards, etc. Please upload at least one picture.Information is only used for authentication, mediLink-Global guarantees your information security.',
    placeholder_occupation: 'Please enter your occupation',
    placeholder_email: 'Please enter your email address',
    others: 'Others',
    male: 'Male',
    female: 'Female',
    shortTime: 'Short-term effectiveness',
    longTime: 'Long-term effectiveness',
    idCardStart: 'ID Start time',
    idCardEnd: 'ID End time',
    areaPlaceholder: 'Please select a region',
    addressPlaceholder: '(Optional) Please enter the full address',
    emailPlaceholder: '(Optional) Please enter your email',
    placeInput: 'Please enter',
    startTime: 'startTime',
    endTime: 'endTime'
  },
  memberAbout: {
    membersCentre: 'Members Centre', // 会员中心
    notification: 'Notification',
    contactUs: 'Contact Us',
    personalQRCode: 'Personal QR Code',
    longPressSaveQR: 'Long press to save the QR code',
    idNumberActivation: 'ID number activation',
    healthCardActivation: 'Health card activation',
    activateMedicalServices: 'Activate Medical Services',
    changesInClaimsAccount: 'Changes in claims account',
    accountManagement: 'Account management',
    langSetting: 'Language',
    feedback: 'Feedback',
    commonProblem: 'FAQ',

    realname: 'Actual name',
    changePhoneNumber: 'Change mobile phone No',
    loginPassword: ' login password',
    changeLoginPassword: 'Change login password',
    processingStatus: 'Processing status',
    dischargeSummary: 'Summary of discharge',
    brithCertify: 'Birth Certificate',
    welfareDesc: 'Welfare Description',
    welfareLimit: 'Welfare Restrictions',
    condition: 'Condition',
    allowance: 'Allowance',
    shareNum: 'Shared Quota',
    shareTimes: 'share Times',
    shareSeeTxt1: 'View policy quota and shared benefits',
    shareSeeTxt2: 'Policy times shared benefits view',
    responsiby: 'Responsibility',
    welfare: 'Welfare',
    consume: 'Consume',
    welfareDetail: 'Welfare Detail',
    welfareLimitTxt1: 'Shared Annual Limit',
    welfareLimitTxt2: 'Number Of Shared Years',
    welfareLimitTxt3: 'The following benefit sharing annual limits',
    welfareLimitTxt4: 'The following benefit sharing annual limits',
    welfareLimitTxt5: 'Cumulative consumption',
    moneyUnit: 'RMB',
    time: 'time',
    warningReminder: 'Benefit will be used up soon'
  },
  accountAbout: {
    changePhone: 'Please enter the phone number you want to bind',
    enterUserName: 'please enter user name'
  },
  text: {
    systemMessage: 'System notifications',
    bussinessMessage: 'Business notifications',
    chinese: 'Chinese',
    english: 'English',
    Y: 'Y',
    N: 'All',
    nodatap1: 'No related content found',
    insuranceCard: {
      add: 'Add insurance card', // 添加保险卡
      inputCard: 'Insurance card No.', // 请输入8000开头的保险卡号
      inputPassword:
        'Password(The initial password is the last six digits of the certificate)', // 请输入保险卡密码
      password: 'Password', // // 请输入保险卡密码
      addFailed: 'Operation failed?', // 操作失败？
      mobileBind: 'Mobile phone quick binding ', // 手机快速绑定
      btn_bind: 'Binding with your insurance card', // 绑定保险卡
      invalid_bind_hint:
        'Your personal information is inconsistent with the policy holder/insured, please try to contact with our customer service team through WeChat official account.',
      phone_not_found:
        'No corresponding mobile phone number was found, please try to contact with our customer service team through our WeChat official account.',
      password_bind: 'Password binding', // 保险卡密码绑定
      mainTit: 'Principal Insured',
      subTit: 'Dependent Insured',
      show: 'Unfold',
      hide: 'Pack up',
      manage: 'Management',
      effect: 'Take effect',
      expire: 'Expire',
      add1: 'Add the insurance card of dependent insured',
      prompt1: 'You can operate on ',
      prompt2: 'the insurance card',
      promptTit: 'Prompt',
      prompt3:
        'After unbinding, we will not be able to provide you with online claim application direct payment medical network query claim progress reminder and other services, are you sure to unbind?',
      promptBtn: 'Unbound',
      promptBtnCancel: 'Cancel',
      forgetPassword: 'Forget password?',
      quicklyBind: 'ID card quick binding',
      quicklyBindByCard: 'Insurance Card quick binding',
      forgetTip:
        'The initial password of the insurance card is the last 6 digits of the ID number reserved when you apply for insurance. If you forget the password or need to reset the password, please contact customer service <a href="tel:4001149606" class="add-card-tel">4001149606</a> for you.'
    },
    ownExpense: {
      waitPay: 'Payable',
      havePay: 'Paid',
      class: 'Category',
      level: 'Level',
      all: 'All',
      serNum: 'Policy number',
      serNum1: 'Claim number',
      serPerson: 'Policy number/card no',
      place: 'Provider Name',
      date: 'Visit date',
      diagnose: 'Diagnosis',
      money: 'Amount to be paid',
      moneypaid: 'Paid',
      opinion: 'Assessment',
      allSelected: 'Select all',
      count: 'Total',
      goPay: 'Pay',
      placeHolder: 'Input insurance card number',
      waitpay: 'Amount to be recovered ',
      havepay: 'Amount recovered '
    },
    ownExpenseDetail: {
      tit: 'Multi-case Pre-authorization',
      tit1: 'Multi-case claims',
      serNum: 'Policy number',
      serNum1: 'Claim number',
      pay: 'Direct billing ',
      havePay: ' Amount recovered ',
      serCard: 'Member Card',
      serPerson: 'Patient name',
      serDate: 'Insurance period',
      cardDate: 'Certificate',
      place: 'Provider Name',
      date: 'Visit date',
      diagnose: 'Diagnosis',
      InsuranceDuty: 'Insurance Duty',
      totalMoney: 'Total amount',
      payMoney: 'Amount of compensation',
      personMoney: 'Selfpay amount',
      waitPay: 'Amount to be paid',
      serStatus: 'Claim status',
      opinion: 'Assessment',
      goPay: 'Pay',
      policyStatus: 'Policy Status'
    },
    BXCardStatus: {
      dealing: 'Processing',
      noPassed: 'Audit not passed',
      done: 'Completed',
      supplementaryMaterials: 'supplementaryMaterials' // 待补充材料
    },
    paymentProgressQuery: {
      all: 'All',
      wait: 'Pending to submit',
      mid: 'Under review',
      have: 'Case closed',
      have1: 'Audit completed',
      time: 'Time',
      promptTit: 'Prompt',
      prompt1: 'After deletion, you will no longer be able to edit the case',
      prompt2: 'Are you sure to delete？',
      promptBtn: 'Delete',
      prompt11:
        'After the revocation, you will no longer be able to edit the case',
      prompt21: 'Are you sure to revocate？',
      promptBtn1: 'Revocate',
      promptBtnCancel: 'Cancel',
      payNum: 'Authorization number',
      payNum1: 'Claim number',
      payNum2: 'NO.',
      pre: 'Pre-authorization request form',
      haved: 'Reimbursement claim',
      pay: 'Direct billing ',
      walfare: 'Welfare',
      serPerson: 'Policy number/Patient name',
      place: 'Provider Name',
      need: 'Need to supplement',
      reason: 'Check the reason',
      edit: 'Modify application',
      delete: 'Delet application',
      change: 'Modify bank account',
      material: 'Upload claim materials',
      material1: 'Supplementary claim materials',
      cancel: 'Revoke the application',
      des: 'EOB',
      des1: 'Explain for the claims',
      result: 'Normal claims for this claim',
      reasonDes: 'Reason',
      materialStatus: 'Materials to be supplemented'
    },
    fileDownload: {
      tit: 'You can choose the following materials to download (multiple choices)：',
      placeHolder: 'Plaese input your email',
      email: 'Send to Email'
    },
    commonQuestion: {
      question1: 'Claims',
      question2: 'Pre-authorizations',
      question3: 'Appointments',
      question4: 'Service flow',
      question5: 'Enrollments',
      question6: 'Others'
    },
    incrementService: {
      familyDoc: 'Family doctor',
      consult: 'Online Health Management',
      appoint: 'Appointment with doctor',
      moreService: 'More Services',
      examinationAppoint: 'Physical examination appointment',
      healthConsultation: 'Health Consultation',
      onlineConsultation: 'Online Health Management',
      videoDoctor: 'Video Doctor',
      onlinePharmacyDelivery: 'Online Pharmacy Delivery'
    },
    sumittedMat: 'SubmittedMaterials',
    nodatap: 'No hospital resources',
    contactUs: {
      tit1: 'Online enquiry',
      titDes1: 'At your service',
      tit2: 'Phone enquiry',
      titDes2: '400-880-8820',
      titDes3: 'Customer 09:00~18:00 online',
      tip3: 'Online Contact'
    },
    networkHospital: {
      tit1: 'New network hospital',
      des1: 'List of mediLink-global cooperation network hospitals this month',
      tit2: 'Medical provider news',
      des2: 'The National Day holiday is here again! The following is the holiday arrangement of some network medical institutions in the middle of the holiday period, members can pay attention to it before going to the doctor~',
      des3: 'Catalogue of areas for hospital labor holiday arrangements in some areas in 2020',
      des4: 'Mid-Autumn Festival & National Day Holiday | Holiday arrangements for some network medical institutions in the mediLink-global',
      des5: 'Holiday arrangements for the Dragon Boat Festival holiday of some network medical institutions in the mediLink-global in 2020',
      des6: "On New Year's Day 2021, some network medical institutions in the mediLink-global will have holiday arrangements."
    },
    supplyMaterial: {
      tit: 'To successfully pass the audit Please provide the following materials ',
      des: 'Remark',
      placeHolder: 'Please enter your other request(125 words)）',
      btn: 'Submit'
    },
    time: {
      all: 'All',
      year: 'A year',
      halfYear: 'Half a year',
      month: 'Three months'
    },

    pay: {
      pay1: 'Personally deductible',
      pay2: 'Family deductible'
    },
    pageTit: {
      BXCard: 'Insurance card',
      BXCardM: 'Insurance card management',
      claimExplain: 'Claim explain',
      hospitalSList: 'Doctor Reviews and Rating',
      networkHospital: 'Medical provider network',
      paymentDetail: 'Details of self-help claims',
      payment: 'Materials supplement for self-service claims',
      paymentDown1: 'Self-service claims operation guide',
      paymentDown2: 'Self-service claims documents',
      ownDetail: 'Details of deductible',
      ownQuery: 'Deductible progress query ',
      preDetail: 'Details of pre-authorization',
      pre: 'Materials supplement for pre-authorization',
      preQuery: 'Pre-authorization progress query',
      preDown1: 'Progress query operation guide',
      preDown2: 'Operation guide documents',
      policyM: 'Policy Manange',
      cardM: 'card Manange',
      nowDynamic: 'Real-time dynamic',
      nowDtit1: 'Company Activities',
      nowDtit2: 'Member benefits',
      idManager: 'Id Management Center',
      IdentityCertifica: 'Identity certification',
      messageSettings: 'Message settings',
      langSetting: 'Language',
      message: 'Message',
      addBXCard: 'Add insurance card'
    },
    btn: {
      down1: 'Download claim documents',
      down2: 'Download claims service operation guide',
      down3: 'Download per-authorization documents',
      down4: 'Download per-authorization service operation guide'
    },
    AppointmentList: {
      title: 'Appointment'
    },
    AppointmentDetail: {
      title: 'Booking details',
      againtitle: 'again Booking',
      eduittitle: 'Fill in the reservation form'
    }
  },
  // mediLink
  btn: {
    setting: 'Setting',
    binding: 'Binding',
    modify: 'Modiy',
    submit: 'Submit',
    nextStep: 'Next',
    nextPage: 'Next',
    claimsExplain: 'Claims to explain', /// 理赔解释
    confirm: 'Confirm', // 确认
    cancel: 'Cancel',

    know: 'I got it', // 知道了
    unbind: 'Uninstall the main card account', // 解除主领卡账号设置
    btxt1: 'You may specify the ending number as', // 您可对尾号为
    btxt2: 'Bank card for operation', // 的银行卡进行操作
    del: 'Delete', // 删除
    setMain: 'Set the main card account number', // 设置为主领卡账号
    childAdd: 'Add/Check Xinyanbao Newborn Enrollment Infomation',
    back: 'Back'
  },
  common: {
    save: 'Save',
    cancleBtn: 'Cancel',
    confirmBtn: 'Confirm',
    require: '-upload requirements', // -上传要求
    sampleTip: '', // 下图为示例说明，要求拍摄文字清晰
    viewDetail: 'View the details',
    sickInfo: 'Patient information',
    upload: 'Doc Upload',
    done: 'Done',
    note: 'Remark',
    notice: 'Claims instruction',
    writeApply: 'Fill up the request',
    placeHolder1: 'Please enter your other request(125 words)', // 请输入您对预授权的其它诉求（125字）
    placeHolder2: 'Please enter your other request(125 words)',
    moneyHolder: 'Please fill in the amount', // 请填写金额
    medicalHolder: 'Please enter the name of the medical institution', // 请输入医疗机构名称
    applayerHolder: 'Please enter the applicant name', // 请输入申请人
    judgeHolder: 'Please enter the diagnosis', // 请输入诊断
    seeDoctorHolder: 'Visit date', // 请选择就诊日期
    seeDoctorHolder1: 'Expected visit date', // 请选择预计就诊日期
    poliyDutyHolder: 'Insurance liability', // 请选择保险责任
    poliyDutyHolder2: 'Treatment type', // 请选择就诊类型
    inHospitalTimeHolder: 'Estimated days of hospitalisation', // 预估住院天数
    medicalPayHolder: 'Estimated cost for the treatment', // 预估医疗费用
    nameHolder: 'Please enter your real name', // 真实姓名
    idNoHolder: 'Valid certificate of identification', // 有效证件号
    bankNoHolder: 'Bank card number', // 银行卡号
    bankDetailHolder: 'Bank branch name', // 银行支行名称
    bankB: 'Bank Branch',
    bankRelationship: 'Relationship with insurancecard', // 与保险卡关系
    back: 'back',
    date: 'Visit date',
    nodata: 'NO Data',
    add: 'add'
  },
  relationship: {
    relationship1: 'Principal',
    relationship2: 'Spouse',
    relationship3: 'Childs',
    relationship4: 'Parents'
  },
  form: {
    chooseRelation: 'Relationship with the person at risk',
    // sickInfo.vue
    medicalInstitution: 'Provider Name', // 医疗机构
    policyNo: 'Policy number', // 保单号
    insured: 'Insured',
    authCategory: 'Authorization category', // 授权类别
    preDoctorTime: 'Visit date',
    preDoctorTime1: 'Expected visit date',
    preDoctorTime2: 'Expect date of hospitalized', // 预计住院日期
    judge: 'Diagnosis', // 诊断
    inHospitalTime: 'Estimated days of hospitalisation',
    medicalPay: 'Estimated cost for the treatment', // 预估医疗费用

    // suppleMaterialList.vue
    preAuthNo: 'Authorization number', // 授权编号
    policyNo_insured: 'Policy number/insured', // 保单号/被保险人
    //= 医疗机构
    //= 就诊日期
    //= 诊断
    needSupple: 'Need to supplement', // 需要补充
    suppleDate: 'Supplementary materials', // 补充材料
    cancelApply: 'Revoke the application',

    // suppleMaterial.vue
    reviewProgress: 'Audit progress', // 审核进度
    reviewResult: 'Audit conclusion', // 审核结论
    failReason: 'Reasons for failing the review', // 审核失败原因
    supplementaryMaterials: 'Materials to be supplemented', // 待补充材料
    //= 补充材料

    // updateDate.vue
    update_text:
      'To successfully pass the audit Please provide the following materials', // 为了顺利通过审核 请提供以下材料
    // uploadComponent
    update_tip: 'The dot item is mandatory input field',
    sample: 'Example', // 示例
    update_text2:
      'Include chemistry test listing, CT, ultrasound, X ray, MRI etc.', // 包括化验清单、CT、B超、X光片、核磁等

    // addBCard.vue form
    addCard: 'Add bank card', // 添加银行卡
    placeChooseCard:
      'Please add your own bank card, and make sure that your name, ID number and bank card number are exactly the same as the bank reservation information', // 请添加本人名下银行卡
    myName: 'Name', // 本人姓名
    idNo: 'ID number', // 证件号码
    cardNo: 'Bank card number', // 银行卡号
    bankName: 'Bank name', // 银行名称
    bankCity: 'Bank city', // 银行所在城市
    bankHolder: 'affiliated bank', // 所属银行
    cityHolder: 'select a province', // 请选择省市
    relationship: 'Relationship with insurancecard' // 与保险卡关系
  },
  bankCard: {
    // bankCard.vue
    // 信用卡、存折、海外个人账户无法用于理赔的支付，请添加您的银行储蓄卡。
    text: 'Credit cards, passbooks, and overseas personal accounts cannot be used to settle claims. Please add your bank savings card.',
    noCard: 'You have not added your bank card', // 您还没有添加银行卡
    addCard: 'Add bank card', // 添加银行卡
    storeCard: 'Debit Card', // 储蓄卡
    openCardBK: 'Bank', // 开户行
    bankaccnm: 'Account Name'
  },
  bankCardExt: [
    'Account Name',
    'Principal',
    'Guardian',
    'Currency',
    'USD',
    'RMB',
    'HKD',
    'Bank Country',
    'Bank Location Country',
    'Enter the swfit code',
    'Select the currency', // 10
    'Bank Name',
    'Bank Address',
    'Account name',
    'USD',
    'GBP',
    'JPY',
    'CAD',
    'EUR',
    'SGD',
    'THB', // 20
    'CHF',
    'DKK',
    'NOK',
    'SEK',
    'ZAR',
    'AUD'
  ],
  insureDuty: {
    head: 'When claims are adjusted in the audit, the interface will be affected...', // 当审核中的理赔发生理赔调整时，会影响到界面...
    wait: 'Waiting period', // 等待期
    paidStand: 'Compensation standards' // 赔付标准
  },
  search: {
    search: 'Search', // 搜索
    hotCity: 'Hot city' // 热门城市
  },
  welfare: {
    // 暂不确定是否接口获取
    welPlan: 'Benefit', // 福利计划
    policyList: 'Insurance clause', // 保险条款
    listTxt1: 'General situation', // 概况
    listTxt2: 'Restrict of medical institutions',
    listTxt3: 'Prior authorization statement', // 事先授权说明
    listTxt4: 'Exclusions statement', // 责任免除说明
    limit1: 'Lifetime limit ({0})', // 终身限额（人民币）
    limit2: 'Total annual limit ({0})', // 总年度限额（人民币）
    area1: 'Safeguard area', // 保障区域
    area2: 'Direct payment area', // 直付区域
    planNo: 'Plan number', // 计划号
    policySort: 'Policy currency type', // 保单币种类
    elecPolicy: 'E-policy', // 电子保单
    expireDate: 'Policy validity',
    welfareDetail: 'Welfare Detail',
    otherPreExisting: 'Member Remark',
    times: 'times',
    OPLimitAmt: 'OP Limit Amt',
    OPLimitTimes: 'OP Limit Times',
    IPLimitAmt: 'IP Limit  Amt',
    IPLimitTimes: 'IP Limit Times'
  },
  list: {
    // preAuth,claimsBusiness中list
    preAuthApply: 'Pre-auth application', // 预授权申请
    preAuthApplySec:
      'Please according to the authorization items stipulated in the insurance clauses', // 请您关注保险条款中约定的授权条目
    preAuthAdd: 'supplemental materials', // 预授权材料补充
    preAuthAddSec: 'To upload the feedback for the pre-authorization problem', // 对授权反馈问题进行补充上传
    preAuthProSearch: 'Pre-authorization status', // 预授权进度查询
    // 授权案件受理进度、历史记录状态查看
    preAuthProSearchSec:
      'Authorization case acceptance progress, view for the history status',
    preAuthGuide: 'Service gudieline', // 预授权服务指南
    preAuthGuideSec: 'operation guide,Materials and process guidelines', // 操作指引、应备材料，流程指引
    preAuthBillDownload: 'Documents download', // 预授权单证下载
    preAuthBillDownloadSec:
      'dowlload the related documents of the processing preauthorization claim', // 进行预授权申请时，相关单证下载
    // claimsBusiness
    autoClaimApply: 'Claim application', // 自助理赔申请
    autoClaimApplySec:
      'Outpatient benefit hospitalization benefit  hospitalization subsidy', // 门诊医疗 住院医疗 住院补贴
    claimMaterAdd: 'Supplemental materials', // 理赔材料补充
    claimMaterAddSec:
      'Claims To upload the feedback for the self-service claims problem', // 对理赔反馈问题进行补充上传
    paidSearch: 'Self-payment amount', // 待缴自付额查询
    paidSearchSec: 'To pay the amount for own expenses', // 对需要自己承担的费用进行缴纳
    autoclaimProSearch: 'Processing status', // 自助理赔进度查询
    autoclaimProSearchSec:
      'Self-service claims acceptance progress, view for the history status', // 自助理赔案件受理进度、历史记录状态查看
    claimServeGuide: 'Service gudieline', // 自助理赔服务指南
    claimServeGuideSec: 'Operation guide,Materials and process guidelines', // 操作指引、应备材料，流程指引
    claimBillDownload: 'Documents download', // 自助理赔单证下载
    claimBillDownloadSec:
      'Dowlload the related documents of the processing self-service claim' // 进行索赔时，相关单证下载
  },
  claimApply: {
    // claimApply.vue form
    // claimNotice.vue
    // formInfo.vue
    paidMoneyTips:
      'This amount is for reference only, the actual payment amount is subject to email or hospital notice!',
    policyPeople: 'Insured', /// 出险人
    effectInsureTime: 'Insurance period', // 保险有效期
    surrenderTime: 'Surrender date', // 退保日期
    applayer: 'Applicant', // 申请人
    relationWithInsured: 'Relationship to insured', // 与出险人关系
    insureLiability: 'Insurance liability', // 保险责任
    treatmentType: 'Treatment type', // 就诊类型
    applyMoney: 'Amount Requested', // 申请金额
    moneyAccount: 'Remittances account', // 汇款账户
    claimAccount: 'Bank Info', // 理赔款账户
    // 其他同上
    // claimProgress.vue
    submittedMaterial: 'Requested Documents', // 已提交材料
    claimProgress: 'Processing status', // 理赔进度
    suppleMaterial: 'Supplementary claim materials', // 待补充理赔材料
    claimMoney: 'Amount of compensation', // 赔付金额
    paidMoney: 'Selfpay amount', // 自付金额
    paidRemark: 'Identification of payment', // 付款标识
    claimsResult: 'Audit conclusion', // 理赔结论

    // 为了保证您在尽可能短的时间内收到理赔款，请按银行名称+所在市+支行名称的规则填写开户银行（示例：招商银行广州市花城支行）
    notice2_: 'dubang' // 杜邦
    // 自助理赔是指传统的报销模式，被保险人在就诊时全额向医疗机构支付医疗费用，随后持发票、病例、检查报告、申请表等资料再向保险公司或保险公司授权的第三方机构提出报销申请。
  },
  // mediLink
  toast: [
    '',
    '' //
  ],
  wallet: [
    'Add the insurance card to the Apple Wallet',
    'Verify your insurance card information',
    'The initial password is the last 6 digits of your valid ID'
  ],
  noticeArr: [
    'Insurance Fraud Notification', // 0
    `
    <p>Important Information – please find below the applicable anti-fraud regulations dictated by the Chinese insurance laws:</p>
    <p>Criminal Law: An applicant, insured person or beneficiary who is guilty of committing insurance fraud shall be sentenced to fixed-term imprisonment for a maximum of 10 years, and concurrently be sentenced to a fine or confiscation of property. Any appraiser, assessor or attester, who deliberately provides false certification documents, thus providing conditions for the applicant, insured person or beneficiary to carry out insurance fraud, shall be charged as an accomplice of insurance fraud (see Article 198 of the Criminal Law of the People’s Republic of China)</p>
    <p>Administrative Law: An applicant, insured person or a beneficiary who commits an insurance fraud act (which does not constitute a crime) shall face a detention of maximum 15 days or a maximum fine of 5,000 Yuan. Any appraiser, assessor or attester who deliberately provides false certification documents, thus providing conditions for the applicant / the insured person / beneficiary to carry out insurance fraud, shall be charged accordingly (see Article 16 and Article 21 of the “Decision of the Standing Committee of the National People’s Congress on Punishment of the Crimes of Undermining the Financial Order”).</p>
    <p>Civil Law: If the applicant fails, due to intention or gross negligence, to perform his/her obligation of making a full and accurate disclosure, or the applicant / insured person intentionally causes the occurrence of an insured event, the insurer has no obligation to make any indemnity or payment of insurance benefit. If the applicant / the insured person / beneficiary, following the occurrence of an insured event, provides forged or altered relevant evidence, information or other proofs or falsifies the cause of the occurrence of the insured event or overstates the extent of the loss, the insurer has no obligation for indemnity or to make payment of the insurance benefit for the portion which is falsified or overstated (see Article 16 and Article 27 of the Insurance Law of the People’s Republic of China)</p>
    `, // 1
    'Statement of Consent', // 2
    `
    <p>I agree that, for any reason, I will pay the full amount of any fees that my insurance policy does not cover during my direct billing service. I agree that Medilink or my insurance company contact me and collect the fees from me via my bank transfer. I further agree that if I do not pay these fees in time, I will be personally responsible for all costs of the collection, which include any reasonable legal costs, related costs incurred by insurance company, Medilink and /or the medical facility.</p>
    <p>For the necessity of underwriting, claim and related service, I agree that insurance company, medical facility and Medilink share my related insurance benefit, health and/or medical information. I authorize any physician, medical facility, pharmacist, insurance company, employer, labor union, or association to release such information to Medilink and my insurance company. The information includes copies of medical records, concerning advice, care or treatment plan. I hereby confirm that the above statements are true and complete. For the necessity of claim and related service,I agree that the insurance company or Medilink handle the claims money on my behalf.I agree to provide any additional information as further required.</p>
    <p>For Direct Billing case or guaranteed case which the medical treatment received in the pre-appointed provider,I hereby authorize the provider or pre-appointed third party to directly bill my insurance company which should make payment of any benefit payable to the provider or pre-appointed third party.</p>
    <p>A photocopy of the above authorization shall be considered as effective and valid as original document.</p>
    `, // 3
    'I have read and agreed to',
    'Have you ever submitted the claim through health insurance policy?', // 5
    'If yes,Please provide the name of the Insurance Company and a copy of your policy.',
    'Y',
    'N',
    'Electronic signature',
    'signature', // 10
    'Remove',
    'Confirm',
    `Please ensure that your electronic signature is clear and complete. The signature will be regarded as your confirmation of this claim application. Your signature will be displayed in the patient's signature section of the Claim Application Form. If the patient is a minor, it shall be signed by the applicant.`,
    'The branch name should not contain bank city, such as: "Beijing" in "Beijing Chaowai Branch"',
    'photograph', // 15
    'After deletion, your claim payment will no longer be paid to the bank card. Are you sure to delete it?',
    'After unbinding, your claim payment will no longer be paid to the bank card. Are you sure to unbind?', // 18
    'Confirm',
    'Cancel', // 20
    'Please enter the password',
    'The modification is successful, please log in again...',
    'Successfully modified', // 23
    '',
    '',
    'Please enter the correct phone number', // 26
    'Added successfully! Thanks for your feedback.', // 27
    'Message Notice', // 28
    '', // 29
    '', // 30
    'There is no selected branch, please return to manually input branch', // 31
    'Added successfully',
    'Choose please'
  ],
  cashierDesk: [
    'MediLink-Global Checkout',
    'To be paid',
    'Product name: ',
    'Order date:',
    'Order No.: ', // 5
    'Order amount: ',
    'WeChat Payment',
    'Card Payment',
    'confirm payment',
    'Payment success', // 10
    'Payment failed',
    'Insufficient bank card balance',
    'Close the prompt box after {0} second',
    'Add bank card',
    'Bank Card List', // 15
    'Single limit {0}，Daily limit {1}',
    'Debit Card',
    'Credit Card',
    'Verify bank card information',
    'Enter the bank card number', // 20
    'Banks reserve mobile phone numbers',
    'Enter the phone number reserved by the bank',
    'SMS verification code',
    'Enter SMS verification code',
    '', // 25
    'Have read and agree to the ',
    'Save to a common card',
    'Card Payment',
    'Get Captcha',
    'SMS verification code has been sent to your bound phone {0}', // 30
    'My usual card',
    'Please fill in your bank card information',
    'Check the supported banks',
    'Cardholder name',
    'Expiry date of the card', // 35
    'ID Type',
    'ID Number',
    'Express Payment Agreement',
    'The expiry date of a credit card is usually written below the card number on the front of the card', // 39 需补充
    'The Card Validation Code', // 40
    'Also known as the credit security code, or CVV2, refers to the 3 or 4 digits on the signature line on the back of a credit card following the end of the card number, as shown in the picture above. The positions of individual cards vary.', // 41 需补充
    'Agreed',
    'Please confirm whether WeChat payment is completed',
    'Search',
    'Paying, please pay and try again',
    'Alipay Payment'
  ],
  extra: ['The reason of cancel: ', 'Preview', 'TOB', 'Remark'],
  claimApplyText: ['Choose policy', 'Request Form'],
  survey: {
    submit: 'Submit',
    search: 'Search Result',
    questions: [
      'Please rate your overall satisfaction with our services:',
      'Please rate our 400 hotline services：',
      'Please rate our claim service：',
      'Please rate our Wechat platform (“MedilinkOnline”)：',
      'Please rate our direct billing network services：',
      'How likely that you would recommend MediLink-Global to your friends or colleagues?',
      'If you have any additional comments to us?',
      'Except for Group High-end Medical Insurance, do you know any following product or service which you are interested in?',
      'Which of the following services would you be interested in?'
    ], // 题目
    subQues: [
      [
        'Speed of connectivity',
        'Service attitude',
        'Expertise (ability of understanding and resolving your problem)',
        'Timeliness of appointment booking service',
        'Success rate of appointment booking service'
      ],
      ['Overall satisfaction', 'Timeliness & Convenience'],
      [
        'User friendliness',
        'System stability',
        'Online functionality of hospital appointment',
        'Online functionality of claim  submission',
        'Online functionality of hospital search',
        'Deductible payment',
        'Document download (insurance clause, Table of Benefit, service manual, etc.)',
        'E-card display'
      ],
      [
        'Meet your medical needs',
        'Service and quality of network hospitals',
        'Service provided by our hospital representatives'
      ],
      [
        'High end medical insurance for children - KidPlus HiCare(XinYanBao)',
        'Individual High end medical insurance - Fami Hicare Plan 2022(ZhenRongYao)',
        'High-end maternity insurance(Xiyan Bao)',
        'International student insurance'
      ]
    ],
    satisfaction: [
      'Very Satisfied',
      'Satisfied',
      'Somewhat satisfied',
      'Neither satisfied nor dissatisfied',
      'Somewhat dissatisfied',
      'Dissatisfied',
      'Very dissatisfied',
      'I don’t know'
    ], // 满意度
    recommend: ['Yes, definitely', 'Yes, probably', 'No'], // 推荐
    interested: ['Yes, interested', 'Yes, bot not interested', 'I don’t know'],
    services: [
      'Physical examinations, interpretation of health reports, health records management',
      'Health lectures or health theme activities',
      'Medical services, such as expert consultations and referral appointments',
      "Pediatrics, such as infant vaccine, ophthalmology and children's physical examination",
      'Vaccinations, including influenza, HPV, and shingles',
      'Chronic disease management and Traditional  Chinese Medical regimen',
      'Others'
    ], // 感兴趣
    recommendReason:
      'Why would you recommend or not recommend MediLink-Global to your friends or colleagues?',
    errMsg: 'please choose',
    success: 'SUCCESS',
    successTip:
      'Thank you for your support, we have received your feedback. We will send you text message with prize information within 10 business days, thanks again!',
    overallMsg: 'Please fill in the complete questionnaire'
  }
}
